<template>
  <div class="container d-flex flex-column px-4 mt-5">
    <p class="fw-bold text-black" :style="{ fontSize: '20px' }">
      {{ t("CL_WITHDRAWAL.SELECT_WITHDRAW_METHOD") }}
    </p>

    <LimitIncreaseButton
      class="limit-increase-button"
      v-if="showLimitIncreasePromotionBanner"
      :expiry-date="newLimitOfferExpiry"
      :limit-increase-amount="newCreditLimit"
      @cta-clicked="clickNewLimitAmountBanner"
    />

    <!--///////////////////// PAYJOY CARD /////////////////////-->
    <div v-if="cardWithdrawal">
      <RadioButtonCard
        name="card-method"
        :text="t('CL_WITHDRAWAL.CARD')"
        :description="cardDescriptionText"
        value="CARD"
        @onchange="onChange(WithdrawMethod.CARD)"
        :isActive="selectedMethod === WithdrawMethod.CARD"
        :disabled="!enabledWithdrawal"
      />
    </div>
    <!--///////////////////// BANK TRANSFER /////////////////////-->
    <div>
      <div v-if="showBankTransferEnable">
        <RadioButtonCard
          name="withdraw-method"
          :text="t('CL_WITHDRAWAL.BANK_TRANSFER')"
          :description="t('CL_WITHDRAWAL.BANK_TRANSFER_DESCRIPTION')"
          value="ONLINE"
          :disabled="
            !transferFlag ||
            bankAccountInfo?.status ===
              AccountValidationStatus.VALIDATION_IN_PROGRESS
          "
          :reason="bankTransferDisabledReason"
          @onchange="onChange(WithdrawMethod.ONLINE)"
          :isActive="selectedMethod === WithdrawMethod.ONLINE"
        >
          <div
            v-if="
              selectedMethod === WithdrawMethod.ONLINE && bankAccountInfo?.clabe
            "
            class="mt-3 w-100 account-number"
          >
            <p class="fw-bold text-black mt-3">
              {{ FormatBankAccountHelper(bankAccountInfo?.clabe) }}
            </p>
            <div>
              <a
                class="me-1 text-success fw-bold"
                @click="$emit('editAccountNumber')"
              >
                <i class="fa fa-edit" />
              </a>
              <a
                class="me-0 text-success fw-bold"
                @click="$emit('unlinkAccount')"
              >
                <i class="fa fa-trash" />
              </a>
            </div>
          </div>
        </RadioButtonCard>
      </div>

      <InfoCard
        v-if="
          (bankAccountInfo?.status === AccountValidationStatus.REJECTED ||
            bankAccountInfo?.status === AccountValidationStatus.CANCELLED) &&
          selectedMethod === WithdrawMethod.ONLINE
        "
        :alert="true"
      >
        <div class="d-flex my-2">
          <div class="content-vertical-align-center">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div>
            {{ t("CL_WITHDRAWAL.UNVERIFIED_BANK_ACCOUNT_LINE_1") }}
            <br />
            {{ t("CL_WITHDRAWAL.UNVERIFIED_BANK_ACCOUNT_LINE_2") }}
          </div>
        </div>
      </InfoCard>
    </div>
    <!--///////////////////// WINDOW PICK-UP /////////////////////-->
    <div v-if="windowWithdrawal">
      <RadioButtonCard
        :disabled="!windowFlag"
        name="withdraw-method"
        :text="t('CL_WITHDRAWAL.CASH_BBVA')"
        :description="t('CL_WITHDRAWAL.CASH_BBVA_DESCRIPTION')"
        value="CASH"
        @onchange="onChange(WithdrawMethod.CASH)"
        :isActive="selectedMethod === WithdrawMethod.CASH"
        class="mb-3"
      />
    </div>

    <div
      class="floating-btn mx-4"
      v-if="!unFreezeCard && selectedMethod == WithdrawMethod.ONLINE"
    >
      <Button
        id="btn-continue"
        class="text-start w-100 p-3"
        :class="disabledBtn ? 'disabled' : ''"
        @click="clickBtn"
        :disabled="disabledBtn"
      >
        <div class="text-white text-center my-auto fw-bold">
          <span>{{ t("CONTINUE") }}</span>
        </div>
      </Button>
    </div>

    <!--///////////////////// WARNING/INFO /////////////////////-->
    <div v-if="displayCard" v-on:click="onClickInfoCard">
      <InfoCard :style="cardStyle">
        <div class="icon-text-container d-flex align-items-left">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
          >
            <mask
              id="mask0_22150_2294"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="23"
              height="24"
            >
              <rect y="0.5" width="23" height="23" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_22150_2294)">
              <path
                d="M11.5 21.6073C11.2445 21.6073 11.0009 21.5594 10.7693 21.4635C10.5377 21.3677 10.326 21.2319 10.1344 21.0562L2.44376 13.3656C2.26806 13.174 2.1323 12.9623 2.03647 12.7307C1.94063 12.4991 1.89272 12.2555 1.89272 12C1.89272 11.7444 1.94063 11.4969 2.03647 11.2573C2.1323 11.0177 2.26806 10.8101 2.44376 10.6344L10.1344 2.94374C10.326 2.75208 10.5377 2.61232 10.7693 2.52447C11.0009 2.43662 11.2445 2.3927 11.5 2.3927C11.7556 2.3927 12.0031 2.43662 12.2427 2.52447C12.4823 2.61232 12.6899 2.75208 12.8656 2.94374L20.5563 10.6344C20.7479 10.8101 20.8877 11.0177 20.9755 11.2573C21.0634 11.4969 21.1073 11.7444 21.1073 12C21.1073 12.2555 21.0634 12.4991 20.9755 12.7307C20.8877 12.9623 20.7479 13.174 20.5563 13.3656L12.8656 21.0562C12.6899 21.2319 12.4823 21.3677 12.2427 21.4635C12.0031 21.5594 11.7556 21.6073 11.5 21.6073ZM10.5417 12.9583H12.4583V7.20833H10.5417V12.9583ZM11.5 15.8333C11.7715 15.8333 11.9991 15.7415 12.1828 15.5578C12.3665 15.3741 12.4583 15.1465 12.4583 14.875C12.4583 14.6035 12.3665 14.3759 12.1828 14.1922C11.9991 14.0085 11.7715 13.9167 11.5 13.9167C11.2285 13.9167 11.0009 14.0085 10.8172 14.1922C10.6335 14.3759 10.5417 14.6035 10.5417 14.875C10.5417 15.1465 10.6335 15.3741 10.8172 15.5578C11.0009 15.7415 11.2285 15.8333 11.5 15.8333Z"
                fill="#C9372C"
              />
            </g>
          </svg>
          <div class="text ms-3" v-html="cardMessage"></div>
        </div>
      </InfoCard>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, PropType, ref, watch } from "vue";
import RadioButtonCard from "@/apps/credit-line/components/RadioButtonCard.vue";
import Button from "@/apps/credit-line/components/Button.vue";
import InfoCard from "@/apps/credit-line/components/InfoCard.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import {
  AccountValidationStatus,
  IBankAccountInfo,
} from "@/apps/credit-line/models/IBankAccountInfo.ts";
import { FormatBankAccountHelper } from "@/apps/credit-line/helpers/formatBankAccount.helper";
import { WithdrawMethod } from "@/apps/credit-line/types/withdrawMethod";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { useRouter } from "vue-router";
import { useNewLimitIncreaseOffer } from "@/apps/credit-line/hooks/useNewLimitIncreaseOffer";
import LimitIncreaseButton from "@/apps/credit-line/components/LimitIncreaseButton.vue";

const props = defineProps({
  enabledWithdrawal: {
    type: Boolean,
    default: true,
  },
  bankAccountInfo: {
    type: Object as PropType<IBankAccountInfo> | null,
  },
  transferFlag: {
    type: Boolean,
  },
  windowFlag: {
    // Summary > >  Window pick-up enabled (determined by FEV2)
    type: Boolean,
  },
  windowWithdrawal: {
    // Settings > >  Window pick-up enabled (determined by YAML file)
    type: Boolean,
  },
  cardWithdrawal: {
    type: Boolean,
    default: true,
  },
  displayNotice: {
    type: Boolean,
    default: false,
  },
  cardTitle: {
    type: String,
    default: "",
  },
  cardMessage: {
    type: String,
    default: "",
  },
  cardDescriptionText: {
    type: String,
    default: "",
  },
  unFreezeCard: {
    type: Boolean,
    default: false,
  },
  showBankTransferEnable: {
    type: Boolean,
    default: true,
  },
});

type WithdrawMethodSelectionPayload = {
  method: WithdrawMethod;
  shouldAdvance: boolean;
};

const emit = defineEmits([
  "setScreenTitle",
  "selectMethod",
  "editAccountNumber",
  "unlinkAccount",
]);

const { t } = useI18n();
const selectedMethod = ref<WithdrawMethod>();
const disabledBtn = ref<boolean>(true);
const cardStyle = ref<string>("normal");
const displayCard = ref<boolean>(false);
const router = useRouter();

const {
  showLimitIncreasePromotionBanner,
  newCreditLimit,
  newLimitOfferExpiry,
} = useNewLimitIncreaseOffer();

onMounted(() => {
  emit("setScreenTitle", t("CL_WITHDRAWAL.SELECT_WITHDRAW_METHOD"));
  if (props.unFreezeCard) {
    cardStyle.value = "warning";
  }
  if (props.displayNotice) {
    displayCard.value = true;
  }
  if (props.transferFlag == false) {
    cardStyle.value = "alert";
  }
});

watch(selectedMethod, (n) => {
  disabledBtn.value = n === null;
});

function onChange(val: WithdrawMethod) {
  if (val === WithdrawMethod.ONLINE) {
    logAnalyticsEvent(
      AnalyticEvents.CreditLine.OnlineTransferSelected,
      "Withdrawal"
    );
  } else {
    logAnalyticsEvent(
      AnalyticEvents.CreditLine.CashPickupSelected,
      "Withdrawal"
    );
  }
  selectedMethod.value = val;
  const payload: WithdrawMethodSelectionPayload = {
    method: val,
    shouldAdvance: val !== WithdrawMethod.ONLINE,
  };
  emit("selectMethod", payload);
}

function onClickInfoCard() {
  if (props.unFreezeCard) {
    router.push({
      name: "CreditLineWithdrawDefrostView",
    });
  }
}

function clickBtn() {
  if (selectedMethod.value !== WithdrawMethod.ONLINE) {
    return;
  }
  emit("selectMethod", { method: WithdrawMethod.ONLINE, shouldAdvance: true });
}

const clickNewLimitAmountBanner = (): void => {
  void router.push({ name: "LimitIncreaseAcceptanceView" });
};

const bankTransferDisabledReason = computed(() => {
  if (!props.transferFlag) {
    return t("CL_WITHDRAWAL.BANK_TRANSFER_DESCRIPTION");
  }

  if (
    props.bankAccountInfo?.status ===
    AccountValidationStatus.VALIDATION_IN_PROGRESS
  ) {
    return t("CL_WITHDRAWAL.VERIFYING_BANK_ACCOUNT");
  }
  return undefined;
});
</script>

<style lang="scss" scoped>
.bottom {
  width: 100%;
  z-index: 1000 !important;
  height: 44px;
  bottom: 5%;
  left: 0;
}

#btn-continue {
  width: 80%;
}

.disabled {
  filter: grayscale(70%) saturate(50%);
  pointer-events: none;
}
.floating-btn-placeholder,
.floating-btn {
  height: 80px;
  width: 100%;
}
.floating-btn {
  background-color: white;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  z-index: 200;
}
.btn-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account-number {
  display: flex;
  align-items: center;
  justify-content: space-between;

  i {
    font-size: 16px;
  }
}

html,
body * {
  font-family: Inter, serif;
}

.content-vertical-align-center {
  line-height: 2.5rem;
}

.icon-text-container {
  display: flex;
  align-items: center;
  padding: 0;
}

.text {
  flex: 1;
  color: black;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
}

.icon {
  width: 23px;
  height: 23px;
  flex-shrink: 0;
}

.limit-increase-button {
  margin-bottom: 12px;
}

.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free"), serif !important;
  font-weight: var(--fa-style, 900) !important;
}
</style>
